module.exports = __webpack_public_path__ + "img/acabado_tipo_concreto.d2738030.png";